// extracted by mini-css-extract-plugin
export default {"label":"A0yLarFkTzNUe31B6vtg"};